import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  list: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: 8,
  },
  tagItem: {
    border: `1px solid ${theme.secondary.s1}`,
    borderRadius: theme.borderRadius.md,
    padding: 16,
    justifyContent: 'start',
  },
}));

export default useStyles;
